<template>
  <el-dialog
    title="修改"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible.sync="dialogFormVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      label-position="right"
      :model="form"
      :rules="rules"
      :label-width="formLabelWidth"
      id="form"
    >
      <el-form-item label="商户分类" prop="pid">
        <el-col :span="18">
          <el-select v-model="form.pid" placeholder="请选择商户分类">
            <el-option
              v-for="item in allMerchant"
              :key="item.id"
              :label="item.merchantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="商户名称" prop="merchantName">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.merchantName"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系人" prop="contacts">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.contacts"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系电话" prop="telephone">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.telephone"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="广告图片" prop="picture">
        <el-col :span="18">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="/api/tool/oss/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-change="beforeAvatarUpload"
            :auto-upload="false"
          >
            <img v-if="imgUrl" :src="imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item class="crop">
        <el-col :span="20">
          <div class="cropper-container">
            <vue-cropper
              ref="cropper"
              :aspect-ratio="1 / 1"
              :src="imgUrl"
              preview=".preview"
              :view-mode="2"
              :drag-mode="'move'"
              :auto-crop-area="1"
              :crop-box-movable="true"
              :crop-box-resizable="false"
            />
            <div style="height:10px"></div>
            <div v-if="!imgUrl" class="cropper-placeholder">裁剪区</div>
            <el-button 
              type="primary" 
              v-if="imgUrl" 
              @click="cropImage"
              :loading="isCropping"
            >
              裁剪
            </el-button>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="跳转url" prop="url">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.url"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-col :span="18">
          <el-input
            type="textarea"
            clearable
            v-model.trim="form.remark"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog('normal')">取 消</el-button>
      <el-button type="primary" @click="addrOrEditTrue" :loading="isSubmitting">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { merchantClassCud, merchantClassAll } from "@/api/url";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "promotional-discounts-add",
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  
  components: {
    VueCropper,
  },

  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: true,
      form: {
        merchantName: "",
        contacts: "",
        telephone: "",
        picture: "",
        url: "",
        remark: "",
        pid: undefined
      },
      rules: {
        // pid: [{ required: true, message: '请选择商户分类', trigger: 'change' }],
        // merchantName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
        // contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        // telephone: [
        //   { required: true, message: '请输入联系电话', trigger: 'blur' },
        //   { validator: validatePhone, trigger: 'blur' }
        // ],
        // picture: [{ required: true, message: '请上传广告图片', trigger: 'change' }],
        // url: [{ required: true, message: '请输入跳转链接', trigger: 'blur' }]
      },
      formLabelWidth: "120px",
      allMerchant: [],
      imgUrl: "",
      isSubmitting: false,
      isCropping: false
    };
  },
  mounted() {
    this.getAllMerchantClass();
    if(this.detail){
      const detail = JSON.parse(JSON.stringify(this.detail));
          this.form = { ...detail };
          this.imgUrl = detail.picture;
          this.$nextTick(()=>{
            this.$refs.cropper.replace(detail.picture);
          })
    }
  },

  methods: {
    async getAllMerchantClass() {
      try {
        const res = await this.$get(merchantClassAll());
        this.allMerchant = res ?? [];
      } catch (error) {
        console.error('获取商户列表失败:', error);
      }
    },

    closeDialog(type) {
      this.$emit("closeDialog", type);
    },

    async addrOrEditTrue() {
      try {
        await this.$refs.form.validate();
        this.isSubmitting = true;
        
        await this.uploadImage();
        const response = await this.$putRequest(
          `${merchantClassCud()}/${this.form.id}`,
          this.form
        );

        if (response.status === 200) {
          this.$message.success("修改成功");
          this.closeDialog("edit");
        } else {
          throw new Error('修改失败');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSubmitting = false;
      }
    },

    beforeAvatarUpload(f) {
      const file = f.raw;
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('请选择图片文件');
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return false;
      }

      this.readFile(file);
      return false;
    },

    readFile(file) {
      if (typeof FileReader !== 'function') {
        this.$message.error('您的浏览器不支持 FileReader');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        this.imgUrl = event.target.result;
        this.$refs.cropper?.replace(event.target.result);
      };
      reader.readAsDataURL(file);
    },

    handleAvatarSuccess(response) {
      if (response?.data) {
        this.form.picture = response.data;
        this.$message.success("图片上传成功");
      }
    },

    async uploadImage() {
      if (!this.imgUrl) return;

      return new Promise((resolve, reject) => {
        this.$refs.cropper.getCroppedCanvas().toBlob(
          async (blob) => {
            try {
              const formData = new FormData();
              formData.append("file", new File([blob], "cropped-image.jpg", {
                type: "image/jpeg"
              }));

              const response = await fetch("/api/tool/oss/upload", {
                method: "POST",
                body: formData
              });
              
              const data = await response.json();
              if (data?.data) {
                this.form.picture = data.data;
                resolve(data);
              } else {
                throw new Error('上传失败');
              }
            } catch (error) {
              this.$message.error("图片上传失败");
              reject(error);
            }
          },
          "image/jpeg",
          0.9
        );
      });
    },

    cropImage() {
      this.isCropping = true;
      try {
        this.imgUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.$message.success("裁剪成功");
      } catch (error) {
        this.$message.error("裁剪失败");
      } finally {
        this.isCropping = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    &:hover {
      border-color: #409eff;
    }
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100%;
  height: auto;
  display: block;
}

.cropper-container {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  height: 80%;
  border: 1px dashed #ccc;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
}

.cropper-placeholder {
  color: #909399;
  font-size: 14px;
}

.el-select {
  width: 100%;
}

.preview {
  width: 100%;
  height: calc(372px * (1/ 1));
  overflow: hidden;
}
</style>